module.exports = __webpack_public_path__ + "img/union.b6b1648d.svg";